import React from 'react'
import qrImage from 'qr-image'

export default class QRCode extends React.PureComponent {
    render() {
        const pngBuffer = qrImage.imageSync(this.props.text, { type: 'png', margin: 1 })
        const dataURI = 'data:image/png;base64,' + pngBuffer.toString('base64')
        return React.createElement('img', { className: 'react-qr', src: dataURI })
    }
}
